export default __webpack_public_path__ + "static/media/Kolkata.ac298a25.png";